import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const SectionTitle = ({ title, subtitle, align = 'center' }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <TitleContainer ref={ref} align={align}>
      {subtitle && (
        <Subtitle
          as={motion.p}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <SubtitleDot /> {subtitle}
        </Subtitle>
      )}
      <Title
        as={motion.h2}
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        {title}
      </Title>
      <Underline
        as={motion.div}
        initial={{ width: 0 }}
        animate={inView ? { width: 60 } : {}}
        transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
        align={align}
      />
    </TitleContainer>
  );
};

const TitleContainer = styled.div`
  text-align: ${props => props.align};
  margin-bottom: 4rem;

  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    margin-bottom: 2.5rem;
  }
`;

const SubtitleDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${props => props.theme.colors.primary};
  margin-right: 8px;
  box-shadow: 0 0 10px ${props => props.theme.colors.glow};
`;

const Subtitle = styled.p`
  color: ${props => props.theme.colors.primary};
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin-bottom: 0.75rem;
  font-family: ${props => props.theme.fonts.mono};
  display: flex;
  align-items: center;
  justify-content: ${props => props.align === 'left' ? 'flex-start' : 'center'};
`;

const Title = styled.h2`
  font-size: 2.8rem;
  font-weight: 800;
  color: ${props => props.theme.colors.text};
  letter-spacing: -1px;
  line-height: 1.2;

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    font-size: 2.2rem;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: 1.6rem;
  }
`;

const Underline = styled.div`
  height: 3px;
  background: ${props => props.theme.colors.gradientPrimary};
  border-radius: 2px;
  margin-top: 1rem;
  margin-left: ${props => props.align === 'center' ? 'auto' : '0'};
  margin-right: ${props => props.align === 'center' ? 'auto' : '0'};
`;

export default SectionTitle;